/**
 * Shared control heights — keep AppInput, AppSelect, AppDatePicker, and SCSS overrides aligned.
 */
export const FORM_CONTROL_SIZE = {
  default: 'h-12 rounded-xl text-sm',
  sm: 'h-9 rounded-xl text-xs',
  md: 'h-10 min-h-10 rounded-xl text-sm',
  lg: 'h-12 rounded-xl text-sm'
} as const

export type FormControlSize = keyof typeof FORM_CONTROL_SIZE
